/** Bump to bust app localStorage on the next load (see AppProvider). */
export const CURRENT_APP_VERSION = "2.1.3";

export const APP_VERSION_STORAGE_KEY = "app_version";
